<template>
  <div class="mstation-introduce-background">
    <div class="mstation-introduce-banner">
      <div class="mstation-introduce-container">
        <div class="mstation-introduce-banner-title">{{ $t("industrial.title") }}</div>
      </div>

      <img class="mstation-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mstation-introduce-container">

      <div class="mstation-introduce-content">
        <div class="mstation-introduce-content-title">
          <div class="mstation-introduce-content-title-text">{{ $t("industrial.background") }}</div>
          <div class="mstation-introduce-line"></div>
        </div>
        <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">{{ $t("industrial.backgroundP1") }}</p>
        </div>

        <!--    <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/industrial1.png">
       </div>-->

        <div class="mstation-introduce-content-title">
          <div class="mstation-introduce-content-title-text">{{ $t("industrial.demand") }}</div>
          <div class="mstation-introduce-line"></div>
        </div>
        <div class="mstation-introduce-content-info1">
          <div class="mstation-introduce-content-info-text">
            <br/><br/>
            <strong>{{ $t("industrial.demandT1") }}</strong><br/>{{ $t("industrial.demandP1") }}<br/><br/>
            <strong>{{ $t("industrial.demandT2") }}</strong><br/>{{ $t("industrial.demandP2") }}
          </div>
          <div class="mstation-introduce-content-img">
            <br/><br/><br/>
            <img  src="../../assets/solution/industrial2.png">
          </div>
          <div class="mstation-introduce-content-info-text">
            <strong>{{ $t("industrial.demandT3") }}</strong><br/>{{ $t("industrial.demandP2") }}<br/><br/>
            <strong>{{ $t("industrial.demandT4") }}</strong><br/>{{ $t("industrial.demandP3") }}<br/><br/>
            <strong>{{ $t("industrial.demandT4") }}</strong><br/>{{ $t("industrial.demandP4") }}
          </div>
        </div>


        <div class="mstation-introduce-content-title">
          <div class="mstation-introduce-content-title-text">{{ $t("industrial.app") }}</div>
          <div class="mstation-introduce-line"></div>
        </div>
        <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>{{ $t("industrial.appT1") }}</strong><br/>
            {{ $t("industrial.appP1") }}
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case1.png">
       </div>

       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>{{ $t("industrial.appT2") }}</strong><br/>
            {{ $t("industrial.appP2") }}
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case2.png">
       </div>


       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>{{ $t("industrial.appT3") }}</strong><br/>
            {{ $t("industrial.appP3") }}
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case3.png">
       </div>


       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>{{ $t("industrial.appT4") }}</strong><br/>
            {{ $t("industrial.appP4") }}
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case4.png">
       </div>

       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>{{ $t("industrial.appT5") }}</strong><br/>
            {{ $t("industrial.appP5") }}
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case5.png">
       </div>

       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>{{ $t("industrial.appT6") }}</strong><br/>
            {{ $t("industrial.appP6") }}
          </p>
        </div>


       <div class="mstation-introduce-content-info">
          <p class="mstation-introduce-content-info-text">
            <strong>{{ $t("industrial.appT7") }}</strong><br/>
            {{ $t("industrial.appP7") }}
          </p>
        </div>
        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/case7.png">
       </div>

       <div class="mstation-introduce-content-title">
          <div class="mstation-introduce-content-title-text">{{ $t("industrial.partner") }}</div>
          <div class="mstation-introduce-line"></div>
        </div>


        <div class="mstation-introduce-content-img">
         <img class="industrial1-introduce-content-img-png" src="../../assets/solution/customer.png">
       </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "companyIntroduce"
}
</script>

<style scoped>
.mstation-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.mstation-introduce-background {
  margin-top: 70px;
}

.mstation-introduce-banner {
  overflow: hidden;
}

.mstation-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}

.mstation-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}

.mstation-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}

/* .mstation-introduce-content-img {
  text-align: center;
}

.mstation-introduce-content-img-png {
  margin-top: 50px;
  width: 300px;
} */


.mstation-introduce-content-title {
  padding-top: 50px;
}

.mstation-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}

.mstation-introduce-content-info {
  margin-top: 40px;
}
.mstation-introduce-content-info-text1 {
  font-size: 18px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: bold;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-top: 70px;
}
.mstation-introduce-content-info .mstation-introduce-content-info-text {
  font-size: 18px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 30px;
}

.mstation-introduce-content-info1 {
  margin-top: 40px;
  display: flex;
}

.mstation-introduce-content-info1 .mstation-introduce-content-info-text {
  font-size: 15px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  flex: 1;
  margin-right: 0px;
  text-align: justify;
}
.mstation-introduce-content-info1 .mstation-introduce-content-img {
  flex: 1.2;
  margin-left: 10px;
  margin-right: 10px;
}
.mstation-introduce-content-info1 .mstation-introduce-content-img img {
  margin-top: 10px;
  width: 100%;
}

.industrial1-introduce-content-img-png {
  margin-top: 10px;
  width: 100%;
}
.mstation-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}

.mstation-introduce-table {
  width: 100%;
  border: 1px solid rgba(240, 240, 240, 1);
}

.mstation-introduce-th {
  background: rgba(73, 145, 201, 1);
  height: 45px;
}

.mstation-introduce-td {
  height: 45px;
}

.mstation-introduce-td:hover {
  background: rgba(73, 145, 201, 0.1);
}

.mstation-introduce-text-th {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  padding-left: 16px;
}

.mstation-introduce-text-td {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  line-height: 25px;
  padding-left: 16px;
}

.mstation-introduce-fa {
  font-size: 16px;
  padding-right: 8px;
}

@media screen and (max-width:482px) {
  .mstation-introduce-container {
    max-width: 100%;
  }
}

@media screen and (min-width:482px) and (max-width:768px) {
  .mstation-introduce-container {
    max-width: 450px;
  }
}

@media screen and (min-width:768px) and (max-width:1100px) {
  .mstation-introduce-container {
    max-width: 736px;
  }
}

@media screen and (min-width:1100px) and (max-width:1444px) {
  .mstation-introduce-container {
    max-width: 1068px;
  }
}

@media screen and (min-width:1444px) {
  .mstation-introduce-container {
    max-width: 1068px;
  }
}
</style>